/* eslint-disable no-console */
import { encodeKebabCase } from '../../../utils/string-utils';

const getActiveSeriesBtn = (series) => {
  const seriesBtns = document.querySelectorAll('[data-awning-option="series"]');
  let activeSeriesElement = seriesBtns[0];
  for (let i = 0; i < seriesBtns.length; i++) { /* eslint-disable-line no-plusplus */
    const btn = seriesBtns[i];
    const btnAttr = btn.getAttribute('data-awning-option-value');
    if (btnAttr.indexOf(series) !== -1) {
      activeSeriesElement = btn;
    }
  }
  return activeSeriesElement;
};

const getActiveLabel = (btn) => {
  const activeLabel = btn.getAttribute('data-active-label');
  if (activeLabel) {
    if (activeLabel === '') {
      return btn.textContent;
    }
    return activeLabel;
  }
  return btn.textContent;
};

const getDefaultLabel = (btn) => {
  const defaultLabel = btn.getAttribute('data-default-label');
  if (defaultLabel) {
    if (defaultLabel === '') {
      return btn.textContent;
    }
    return defaultLabel;
  }
  return btn.textContent;
};

const updateSeriesButtonLabels = (active) => {
  const { element, option } = active;
  const btnList = document.querySelectorAll(`[data-awning-option="${option}"]`);
  [].map.call(btnList, (btn) => {
    if (btn === element) {
      btn.textContent = getActiveLabel(btn);
      btn.classList.add('button-white-lg');
      btn.classList.remove('button-light-blue-lg');
    } else {
      btn.textContent = getDefaultLabel(btn);
      btn.classList.remove('button-white-lg');
      btn.classList.add('button-light-blue-lg');
    }
  });
};

const updateSeriesHeading = (series) => {
  const stepTitle = document.querySelector('#model h3');
  const seriesLabel = series.substr(0, series.indexOf(' '));
  let stepTitleHtml = stepTitle.innerHTML;
  stepTitleHtml = stepTitleHtml.replace(/Platinum|SunSetter/, seriesLabel);
  stepTitle.innerHTML = stepTitleHtml;
};

const updateSeriesWrapper = (state) => {
  const wrapper = document.getElementById('awning-configurator');
  wrapper.classList = `build-awning-steps ${encodeKebabCase(state.series)}`;
};

export {
  getActiveSeriesBtn,
  updateSeriesButtonLabels,
  updateSeriesHeading,
  updateSeriesWrapper,
};
/* eslint-enable no-console */
